module.exports = __webpack_public_path__ + "static/media/VT323-Regular.d55abc3c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Fonts/VT323-Regular.ttf
// module id = 115
// module chunks = 0